import { List } from 'immutable';

import AppDispatcher from '../dispatcher/AppDispatcher';
import ConfigService from '../services/ConfigService';
import { ActionTypes } from '../constants/AppConstants';
import JourneyNotificationStore from '../stores/JourneyNotificationStore';

const JourneyNotificationActions = {

    async fetchMessages (search) {
        let messages;
        try {
            messages = await ConfigService.loadJourneyNotifications(search.getJsonForJourneyNotification());
            AppDispatcher.dispatch({
                actionType: ActionTypes.JOURNEY_NOTIFICATIONS_LOADED,
                search,
                messages
            });
        } catch (e) {
            console.error('Failed to load journey notifications', e);
            messages = new List();
        }
        return { messages: messages.filter((message) => !JourneyNotificationStore.isJourneyNotificationDismissed(message.id)) };
    },

    async dismissMessages () {
      AppDispatcher.dispatch({
          actionType: ActionTypes.JOURNEY_NOTIFICATIONS_DISMISSED
      });
    }
};

export default JourneyNotificationActions;



// WEBPACK FOOTER //
// ./src/actions/JourneyNotificationActions.js